import { jsxDEV as reactJsxDEV } from "react/jsx-dev-runtime";
import { wrap } from "../wrap";

export const jsxDEV = wrap(reactJsxDEV);
